/**
 * Converts a file to a base64 encoded string.
 *
 * @function
 * @param {File} file - The file to be converted.
 * @returns {Promise<string>} A promise that resolves with the base64 encoded string of the file.
 * @throws {Error} Throws an error if there is an issue during the read process.
 *
 */
export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (e) => reject(new Error(e));
  });
